import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import logsReducer from './slices/logsSlice';
import kpisReducer from './slices/kpisSlice';
import uiReducer from './slices/uiSlice';
import { injectStore } from '../services/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    logs: logsReducer,
    kpis: kpisReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: import.meta.env.VITE_DEBUG_MODE === 'true',
});

// Inject store into api module to avoid circular dependency
injectStore(store);
